<template>
  <div class="details">
    <div class="details-nav">
      <div class="nav-box">
        <div class="nav-box-img">
          <el-image :lazy="true" :src="require('../../assets/image/details/position.png')" fit="fill"></el-image>
        </div>
        <div>当前位置：</div>
        <div class="details-bread">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{  path: '/resource/all',query:{ref:'ref99999'} }">资源</el-breadcrumb-item>
            <el-breadcrumb-item>{{bookDetails.bookName}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>

      </div>
    </div>
    <div class="details-show">
      <div class="details-show-title">
        <div>
          {{bookDetails.bookName}}
        </div>
        <div class="details-show-brief">
          {{ bookDetails.brief }}
        </div>
      </div>
      <audiosVue :musics="musics" class="vodeps" ref="hlsplayRef" v-if="isShow"></audiosVue>
    </div>
  </div>
</template>

<script>
  import {getBookById} from '../../api/resource'
  import audiosVue from '../../components/common/audios.vue';

  export default {
    name: 'PortalDetailShows',

    data() {
      return {
        isShow: false,
        bookDetails: {
          bookName: '',
          // 地区
          address: '',
          // 收藏地
          collectionplace: '',
          // 类别
          category: '',
          // 民族
          nation: '',
          // 页数
          pages: '',
          // 简介
          brief: '',
          // 责任者
          author: '',
          audioUrl: '',
          coverPicture: ''
        },
        datalist: [],
        musics: [{
          title: "歌曲名称",
          artist: "演唱者",
          src: "",
          pic: "封面图片URL",
          lrc: "歌词或歌词文件的URL",
        }]
      };
    },

    mounted() {
      this.init()
    },

    methods: {
      getDetail() {
        return new Promise((provide, reject) => {
          let params = {
            bookId: this.$route.query.bookId
          }
          getBookById(params).then(res => {
            if (res.data.code == 200 && res.data.data) {
              this.datalist = JSON.parse(JSON.stringify(res.data.data))
              // 提取元数据模版值
              let con = [
                {
                  title: '题名',
                  field: 'bookName'
                },
                {
                  title: '馆藏地址',
                  field: 'address'
                },
                {
                  title: '地区',
                  field: 'collectionplace'
                },
                {
                  title: '分类',
                  field: 'category'
                },
                {
                  title: '民族',
                  field: 'nation'
                },
                {
                  title: '页数',
                  field: 'pages'
                },
                {
                  title: '简介',
                  field: 'brief'
                },
                {
                  title: '责任者',
                  field: 'author'
                },
                {
                  title: '音频路径',
                  field: 'audioUrl'
                },
                {
                  title: 'coverPicture',
                  field: 'coverPicture'
                },
              ]
              con.forEach(e => {
                const ds = this.datalist.find(i => {
                  return i.captions == e.title
                })
                if (ds) {
                  this.bookDetails[e.field] = ds.attributeValue
                }
              });
              if (this.bookDetails['audioUrl']) {
                provide(this.bookDetails['audioUrl'])
              }

            }
          })
        })
      },
      async init() {
        let srcd = await this.getDetail()
        if (srcd) {
          this.isShow = true
        }
        console.log(this.bookDetails);
        this.musics = []
        srcd.split(',').forEach((e, index) => {

          let obj = {
            title: srcd.split(',').length > 1 ? this.bookDetails.bookName + (index + 1) : this.bookDetails.bookName,
            artist: this.bookDetails.author || ' ',
            src: e.replace('/home/uftp/books/', '/fileBookWeb/'),
            pic: this.bookDetails['coverPicture'] == '/' ? require('../../assets/image/resource/pic-audio.jpg') : ''
          }
          this.musics.push(obj)
        })
        // this.musics=[{
        //     title: "重庆洪崖洞",
        //     artist: "黄晓明",
        //     src: "https://www.cambridgeenglish.org/images/153149-movers-sample-listening-test-vol2.mp3",
        //     pic: "封面图片URL",
        //     lrc: "歌词或歌词文件的URL",
        // },{
        //     title: "重庆洪崖洞2",
        //     artist: "黄晓明s",
        //     src: "https://www.w3school.com.cn/i/horse.ogg",
        //     pic: "封面图片URL",
        //     lrc: "歌词或歌词文件的URL",
        // }]
        // if(srcd.attributeValue !='/'){
        //     this.src = srcd.attributeValue
        // }
      }
    },
    components: {
      audiosVue
    }
  };
</script>

<style lang="less" scoped>
  .details {
    background: url('../../assets/image/resource/res_main.png');
    padding-top: 1.042rem;
    padding-bottom: 2.083rem;

    .details-nav {
      width: 62.5rem;
      height: 2.604rem;
      margin: 0 auto;
      background-color: #fff;

      .nav-box {
        display: flex;
        height: 100%;
        align-items: center;
        padding-left: 1.042rem;
        font-size: 0.833rem;
        color: #333333;

        .nav-box-img {
          margin-right: 0.625rem;

          .el-image {
            width: 0.677rem;
            height: 0.833rem;
          }
        }

        .details-bread {
          /deep/ .el-breadcrumb {
            .el-breadcrumb__item {
              .el-breadcrumb__inner.is-link {
                font-size: 0.833rem;
                color: #333333;
                font-weight: unset;
              }

              .el-breadcrumb__inner {
                color: #b1222b;
              }
            }
          }

        }
      }
    }

    .details-show {
      width: 62.5rem;
      // height: 2.604rem;
      margin: 0 auto;
      background-color: #fff;
      margin-top: 0.625rem;
      padding: 0 1.563rem;
      padding-bottom: 5rem;

      .details-show-title {
        font-size: 1.25rem;
        font-weight: bold;
        color: #333333;
        text-align: center;
        padding-top: 2.5rem;
        padding-bottom: 0.833rem;
        border-bottom: 1px solid #ddd;
        margin-bottom: 1.563rem;

        .details-show-brief {
          font-size: 0.8rem;
          font-weight: normal;
          text-align: left;
          line-height: 1.5;
          margin-top: 10px;
          text-indent: 2em
        }
      }
    }
  }
</style>
